import { render, staticRenderFns } from "./AboutCytomineModal.vue?vue&type=template&id=45dd3ad7&scoped=true&"
import script from "./AboutCytomineModal.vue?vue&type=script&lang=js&"
export * from "./AboutCytomineModal.vue?vue&type=script&lang=js&"
import style0 from "./AboutCytomineModal.vue?vue&type=style&index=0&id=45dd3ad7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd3ad7",
  null
  
)

export default component.exports